import { Input, Td, Tr } from '@chakra-ui/react'
import onlyNumber from '../../../../utilities/onlyNumber'
import { TableRowProps } from './types'

export default function TableRow({
    banknote,
    quantity,
    onChange,
    autoFocus
}: TableRowProps) {
    return (
        <Tr>
            <Td>S/{banknote}</Td>
            <Td p="0">
                <Input
                    size="sm"
                    borderTopWidth="0"
                    borderBottomWidth="0"
                    value={quantity}
                    textAlign="center"
                    onChange={ev =>
                        onChange(Number(onlyNumber(ev.target.value, {})))
                    }
                    autoFocus={autoFocus}
                />
            </Td>
            <Td>{(banknote * quantity).toFixed(2)}</Td>
        </Tr>
    )
}
